module.exports = [{
      plugin: require('../node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[],"icon":false,"maintainCase":false,"removeAccents":true,"elements":["h2","h3"],"offsetY":0,"className":"anchor"},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"defaultLayouts":{"default":"/app/node_modules/@interness/web-core/src/templates/mdx/default.js"},"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-autolink-headers","options":{"icon":false,"maintainCase":false,"removeAccents":true,"elements":["h2","h3","h4"]}},"gatsby-remark-unwrap-images",{"resolve":"gatsby-remark-images","options":{"maxWidth":1980,"quality":85,"linkImagesToOriginal":false,"withWebp":false}},{"resolve":"gatsby-remark-external-links","options":{"target":null,"rel":"nofollow noopener noreferrer external"}}],"extensions":[".mdx"],"lessBabel":false,"remarkPlugins":[],"rehypePlugins":[],"mediaTypes":["text/markdown","text/x-markdown"],"root":"/app","JSFrontmatterEngine":false,"engines":{}},
    },{
      plugin: require('../node_modules/@interness/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-150},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://okkasionen.juwelierhohage.de"},
    },{
      plugin: require('../node_modules/@interness/web-core/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"/app/node_modules/@interness/theme-sonora/src/utils/typography.js","omitGoogleFont":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/app/node_modules/@interness/theme-sonora/src/components/Layout/Layout.js"},
    },{
      plugin: require('../node_modules/@interness/ecommerce-addon/gatsby-browser.js'),
      options: {"plugins":[],"display_name":"Shop","path":"shop"},
    }]
